<template>
  <div class="result-container">
    <div class="result-content">
      <el-result icon="success" title="录入成功" subTitle="恭喜您信息录入成功，后续服务请联系您的专属学习顾问！">
        <template slot="extra">
          <el-button class="result_btn" type="primary" size="medium" @click="closeCurrentPage()">关闭</el-button>
        </template>
      </el-result>
    </div>
  </div>
</template>

<script>
  import Common from '@/utils/common'
  import wx from 'weixin-js-sdk'
    export default {
        name: "result",
      data:function(){
          return{

          }
      },
      methods:{
        closeCurrentPage:function(){
          var vm = this;
          //判断是否是在微信端
          if (Common.Util.isWeiXin()) {
            //微信关闭当前窗口
            wx.closeWindow();
          } else {
            //浏览器关闭当前窗口
            window.open("about:blank", "_self").close();
          }
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/result.vue